import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronDownBold = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4.12312 6.75L9 11.8492L13.8769 6.75L15.375 8.31984L9 15L2.625 8.31984L4.12312 6.75Z",
		fill: "currentColor"
	})
});
export default SvgChevronDownBold;
